import React from "react";
import { FormWrapper } from "../../../../../../../shared/components/FormWrapper";
import { developOptions } from "../../../../../../../../config/developOptions";
import { fakeFormsDataKYCManual } from "../../../../../../../../utils/fakeFormsData";
import { AddressFormResetValues } from "../../../../AutocompleteAddressHeadless/constants/AddressFormResetValues";

export const AddressFormWrapper = ({ children, data }) => {
  const defaultValues = data?.address
    ? data
    : developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES
    ? fakeFormsDataKYCManual.ADDRESS_DATA_FORM
    : AddressFormResetValues;

  return <FormWrapper defaultValues={defaultValues}>{children}</FormWrapper>;
};
